import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import RevisorShortcuts from "./revisorShortcuts";
import RevisorDocuments from "./revisorDocuments";
import { PanelWithDivider } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ShortcutsWidget: React.FC = () => {
  return (
    <Grid item container rowGap={2} direction="row">
      <PanelWithDivider title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.Documents)}>
        <RevisorDocuments />
      </PanelWithDivider>
      <PanelWithDivider title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Shortcuts)}>
        <RevisorShortcuts />
      </PanelWithDivider>
    </Grid>
  );
};

export default ShortcutsWidget;
